import React from 'react';
import { View } from '@react-pdf/renderer';
import { styles } from "./EmergencyTreatmentPDFStyle";
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { IAddress } from '../../../models/IAddress';

interface IEmergencyTreatmentPDFApplicationInformation {
    treatmentNumber: string;
    dateOfTreatment: Date;
    extraInfo: string;
    billable: boolean;
    dateSent: Date;
    renderInformationField: (label: string, value: string | undefined) => void;
    formatAddress: (address: IAddress | undefined) => string;
}

export const EmergencyTreatmentPDFApplicationInformation: React.FunctionComponent<IEmergencyTreatmentPDFApplicationInformation> = ({ treatmentNumber, dateOfTreatment, extraInfo, billable, dateSent, renderInformationField, formatAddress }) => {
    return (
        <>
            <View style={styles.smallBox}>
                {
                    renderInformationField("Akuträkningsnr.", treatmentNumber)
                }
                {
                    renderInformationField("Utförandedatum", dateTimeToDateString(dateOfTreatment))
                }
                {
                    renderInformationField("Övrig information", extraInfo)
                }
            </View>
            <View style={styles.smallBox}>
                {
                    renderInformationField("Fakturerbar", billable ? "Ja" : "Nej")
                }
                {
                    renderInformationField("Skickad", dateSent === null ? "Ej skickad" : dateTimeToDateString(dateSent))
                }
            </View>
        </>
    )
}